import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=79f0a0ad&scoped=true"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=79f0a0ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0a0ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f0a0ad')) {
      api.createRecord('79f0a0ad', component.options)
    } else {
      api.reload('79f0a0ad', component.options)
    }
    module.hot.accept("./goodsManage.vue?vue&type=template&id=79f0a0ad&scoped=true", function () {
      api.rerender('79f0a0ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsNameTag/goodsManage.vue"
export default component.exports